export type INotificacionesTransformadas = {
	id: number;
	name: string;
	listaTipoNotificacionPrioridad: IListaTipoNotificacion[];
};

export enum Priordades {
	Alta = 'Alta',
	Media = 'Media',
	Baja = 'Baja'
}

export type IListaTipoNotificacion = {
	tipoNotificacion: {
		id: number;
		descripcion: string;
	};
	prioridad: {
		id: number;
		descripcion: Priordades;
	};
};
		

export type IPriordadesNotificacion = {
	tipoTramite: {
		id: number;
		descripcion: string;
	};
	listaTipoNotificacionPrioridad: IListaTipoNotificacion[];
};

export type IEmisor = {
  	nif: string;
  	tipoSector: {
		id: number;
		descripcion: string;
  	};
  	email: string;
  	telefono: string;
  	direccion?: {
		codigoPostal?: number;
		codigoProvincia?: string;
		descripcionProvincia?: string;
		codigoMunicipio?: string;
		descripcionMunicipio?: string;
		codTipoVia?: string;
		descripcionTipoVia?: string;
		nombreVia?: string;
		numeroVia?: string;
		bloque?: string;
		escalera?: string;
		piso?: string;
		puerta?: string;
  	};
  	prioridadesNotificacion: IPriordadesNotificacion[];
  	id?: number;
  	nombre?: string;
  	fechaAlta?: string;
  	fechaBaja?: string;
  	listaTiposTramite?: 
	Array<{
		id: number;
		descripcion: string;
	}>;
};
